define('supplierImprintTechnologiesFiltersEditView',[
  'module',
  'backbone',
  'underscore',
  'filtersBannerEditView',
  'template!supplierImprintTechnologiesFiltersEditView'
], function (
  Module,
  Backbone,
  _,
  FiltersBannerEditView,
  Tpl
) {
  'use strict';

  Module.exports = FiltersBannerEditView.extend({
    template: Tpl,
    className: 'supplier-imprint-technologies-filters-edit-view ' + FiltersBannerEditView.prototype.className,
    windowTitle: _.i18n('suppliers.imprintTechnologies.filters.edit', 'Edit filters for supplier imprint technologies'),

    ui: _.extend({
      code: '.body .code input',
      supplier: '.body .supplier input',
      name: '.body .name input',
      colorModeType: '.body .color-mode-type input',
      maxNumberOfColors: '.body .max-number-of-colors input'
    }, FiltersBannerEditView.prototype.ui),

    initialize: function () {
      this.tableView = this.options.bannerView.options.tableView;
      FiltersBannerEditView.prototype.initialize.apply(this, arguments);
    },

    onRender: function () {
      this.ui.code.val(this.model.get('code'));
      this.ui.supplier.val(this.model.get('supplier'));
      this.ui.name.val(this.model.get('name'));
      this.ui.colorModeType.val(this.model.get('colorModeType'));
      this.ui.maxNumberOfColors.val(this.model.get('maxNumberOfColors'));

      FiltersBannerEditView.prototype.onRender.apply(this, arguments);
    },

    onConfirm: function () {
      this.model.set({
        code: this.ui.code.val().trim(),
        supplier: this.ui.supplier.val().trim(),
        //name: this.ui.name.val().trim(),
        colorModeType: this.ui.colorModeType.val().trim(),
        maxNumberOfColors: this.ui.maxNumberOfColors.val().trim()
      });

      FiltersBannerEditView.prototype.onConfirm.apply(this, arguments);
    },

    onReset: function () {
      this.ui.code.val('');
      this.ui.supplier.val('');
      //this.ui.name.val('');
      this.ui.colorModeType.val('');
      this.ui.maxNumberOfColors.val('');
    }
  });
});

